import { render, staticRenderFns } from "./domaine-vincent-bouzereau.vue?vue&type=template&id=9c073ce4&scoped=true"
import script from "./domaine-vincent-bouzereau.vue?vue&type=script&lang=js"
export * from "./domaine-vincent-bouzereau.vue?vue&type=script&lang=js"
import style0 from "./domaine-vincent-bouzereau.vue?vue&type=style&index=0&id=9c073ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c073ce4",
  null
  
)

export default component.exports